<div class="badge fx-center-all" [class.expanded]="expanded" [style.background-color]="expanded ? bgColor : textColor" [style.color]="textColor">
    <span class="badge-text caption caption--sm">{{ badgeText }}</span>
</div>
